import * as Yup from "yup";

/**
 * The function returns a Yup validation schema for a quick quote form with various required fields and validation rules.
 */
export default function getQuickQuoteValidationSchema() {
  return Yup.object().shape({
    proposer_first_name: Yup.string()
      .required("Name is required")
      .matches(/^[a-zA-Z]+([a-zA-Z ]*)$/, "Please give valid name")
      .min(3, "Name must have more than 3 digits"),

    gender: Yup.string().required("Gender is required"),

    proposer_occupation: Yup.string().required("Occupation is required"),

    proposer_annual_income: Yup.number()
      .required("Annual Income is required")
      .min(50000, "Annual Income must be minimum 50000"),

    proposer_sum_insured: Yup.number()
      .required("Sum Insured is required")
      .min(1, "Sum Insured must be greater than 0"),

    insureds: Yup.array().of(
      Yup.object().shape({
        relationship_with_proposer: Yup.string(),

        first_name: Yup.string().when("relationship_with_proposer", {
          is: (val) => val && val.length > 0, // val is not empty
          then: Yup.string()
            .matches(/^[a-zA-Z]+([a-zA-Z ]*)$/, "Please give a valid name")
            .min(3, "Name must have more than 3 characters")
            .required("Name is required"),
          otherwise: Yup.string().nullable(),
        }),

        annual_income: Yup.number().when("relationship_with_proposer", {
          is: (val) => val && val.length > 0, // val is not empty
          then: Yup.number().required("Annual Income is required"),
          otherwise: Yup.number().nullable(),
        }),

        occupation: Yup.string().when("relationship_with_proposer", {
          is: (val) => val && val.length > 0, // val is not empty
          then: Yup.string().required("Occupation is required"),
          otherwise: Yup.string().nullable(),
        }),
      })
    ),
  });
}
